import { AdSlotContainerLifecycleEvent } from './ad-slot-container-lifecycle.event';
import { PublicRecommendationItemDto } from '../../../dto/recs.dto';

export class AdSlotContainerPreRenderEvent extends AdSlotContainerLifecycleEvent {
  private items: PublicRecommendationItemDto[] = [];

  public getItems (): PublicRecommendationItemDto[] {
    return this.items;
  }

  public setItems (items: PublicRecommendationItemDto[]): void {
    this.items = items;
  }
}
